import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Radio, RadioGroup } from "rsuite";
function SelectDataSource({ dataSource, setDataSource }) {
    const defaultChecked = !!dataSource;
    //console.log(`init defaultChecked: ${defaultChecked}`);
    //console.log(`init dataSource: ${dataSource}`);
    function handleChangeDatasource(value, event) {
        //console.log(`defaultChecked: ${defaultChecked}`);
        //console.log(`dataSource: ${dataSource}`);
        //console.log(`value: ${value}`);
        //console.log(`event: ${event}`);
        setDataSource(value);
    }
    return (_jsxs(RadioGroup, { name: "select-data-source", defaultChecked: defaultChecked, defaultValue: dataSource, onChange: handleChangeDatasource, children: [_jsx(Radio, { value: "instagram", children: "Instagram" }), _jsx(Radio, { value: "amazon", children: "Amazon" })] }));
}
export default SelectDataSource;
